<template>
  <div id="login" :style="background">
    <div class="el-login-form">
      <div class="el-text-form">
        <div class="el-text-form-title">
          <h4>欢迎登录使用<br/>中欧铁路运踪查询系统</h4>
        </div>
        <div class="el-text-form-line"></div>
<!--        <router-link class="el-link-login" :to="{path: '/resgiter'}">{{haveId}}<span class="loginBig">注册</span></router-link>-->
        <span class="el-text-form-copyright">运踪信息查询平台 Copyright © 2014-2021</span>
      </div>
      <div class="el-sub-form">
        <div class="el-sub-title">
          <h4>账号登录</h4>
          <div class="el-sub-line">
            <div class="el-sub-line-inner"></div>
          </div>
        </div>
        <div class="el-cont-form">
          <el-form
            :model="loginForm"
            ref="loginForm"
            :rules="rules"
            class="demo-ruleForm">
            <el-form-item label="" prop="logName" class="el-lin">
              <el-input
                v-model="loginForm.logName"
                type="text"
                placeholder="请输入账号">
                <template slot="prepend">
                  <div class="el-form-icon"><i class="el-icon-user"></i></div>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="" prop="logPwd" class="el-lin">
              <el-input
                v-model="loginForm.logPwd"
                type="password"
                placeholder="请输入密码">
                <template slot="prepend">
                  <div class="el-form-icon"><i class="el-icon-lock"></i></div>
                </template>
                </el-input>
            </el-form-item>
            <el-form-item label="" prop="logCode" class="el-lin">
              <el-input
                v-model="loginForm.logCode"
                @keyup.enter.native="submitForm('loginForm')"
                type="text"
                placeholder="验证码">
                <template slot="append">
                  <div class="el-imgCode" @click="getImgcode">
                    <img :src="imgCode" alt="" />
                  </div>
                </template>
                </el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                style="width: 100%"
                type="primary"
                @click="submitForm('loginForm')"
                >立即登录</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Login",
  data() {
    return {
      haveId: "还没有账号？请立即前往",
      background: {
        background: "url(./static/images/132.jpg) no-repeat",
      },
      loginTitle: "欢迎登陆",
      loginImg: "./static/images/1.png",
      toResgiter: {
        "font-size": "14px",
        color: "#409eff",
        float: "right",
      },
      loginForm: {
        logName: "",
        logPwd: "",
        logCode: "",
      },
      imgCode: "http://super.jagich.com/captcha.html",
      rules: {},
    };
  },
  mounted() {},
  methods: {
    //获取验证码
    getImgcode() {
      var mathRandom = Math.random();
      this.imgCode = "http://super.jagich.com/captcha?id=" + mathRandom;
    },
    //校对用户名
    userLogin() {
      this.$axios
        .post("login/login", {
          username: this.loginForm.logName,
          password: this.loginForm.logPwd,
          code: this.loginForm.logCode,
        })
        .then((res) => {
          if (res.data.code == 0) {
            //将token存储到localStorage
            localStorage.setItem("token", res.data.data.token);
            //跳转到默认界面后刷新
            this.$router.push("/Boxnumber");
            this.$router.go(0);
            this.$message({
              message: res.data.msg, //弹出返回信息
              type: "success",
              offset: 150,
            });
          } else if (res.data.code == 400) {
            this.$message({
              message: res.data.msg, //弹出返回信息
              type: "warning",
              offset: 150,
            });
          }
          console.log(res.data.code);
          console.log(res);
        })
        .catch((err) => {
          this.$message({
            message: res.data.msg, //弹出返回信息
            type: "warning",
            offset: 150,
          });
        });
    },
    //用户提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.userLogin();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style>
  .el-menu--horizontal>.el-menu-item.is-active {
    color: #409EFF !important;
  }

  .el-input-group__append {
    padding: 0;
  }
</style>

<style scoped>
@import "./log/login.css";
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue